import React from 'react';
import { css } from '@emotion/react';

import { BaseCarousel, createSlickSettings } from '~/src/components/carousels/BaseCarousel';
import { LazyRender } from '~/src/components/LazyRender';
import { useLocale } from '~/src/components/LocaleProvider';

import { TestimonialCard, spaceBetweenCards } from './TestimonialCard';
import { testimonialsDataEN } from './testimonialsDataEN';
import { testimonialsDataES } from './testimonialsDataES';
import { CarouselItem } from './types';

const slickSettings = createSlickSettings({
  sm: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    lazyLoad: 'progressive' as const,
    arrows: false,
  },
  md: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    lazyLoad: 'progressive' as const,
    arrows: false,
  },
  lg: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    variableWidth: false,
    arrows: true,
  },
  xl: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    variableWidth: false,
    arrows: true,
  },
  xxl: {
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    lazyLoad: 'progressive' as const,
    variableWidth: false,
    arrows: true,
  },
});
const carouselProps = {
  paddingTop: '0',
  paddingBottom: '0',
  button: null,
  deprecatedEnableCarouselInvisibleCard: false,
  containerStyles: { padding: 0 },
  slickSettings: { ...slickSettings, autoplay: true, speed: 2000 },
  overrideSlickCarouselCSS: css({
    '.slick-list': { padding: '0', overflowX: 'visible', marginTop: '0px !important' },
    '.slick-slide': { paddingLeft: 0, paddingRight: `${spaceBetweenCards}px` },
    '.slick-arrow': {
      border: '1px solid #E9E9E9',
      boxShadow: '2px 2px 15px 0px rgba(0, 0, 0, 0.04)',
    },
  }),
};

export const TestimonialCarousel: React.FC<{ className?: string }> = props => {
  const { locale } = useLocale();

  const data = locale === 'es' ? testimonialsDataES : testimonialsDataEN;

  return (
    <div {...props}>
      <LazyRender placeholder={<TestimonialCard.Placeholder />}>
        <BaseCarousel<CarouselItem>
          items={data}
          renderCard={(cardProps: { item: CarouselItem }) => {
            return <TestimonialCard {...cardProps} />;
          }}
          getReactKey={(i: CarouselItem) => i.id}
          {...carouselProps}
        />
      </LazyRender>
    </div>
  );
};
